import { useAtomValue } from 'jotai';

import { ClientInformationCardConnected } from '@grow-therapy-team/seedling-components';

import { SelectedClientPatientNoteWrapper } from '../patient-note/PatientNoteWrapper';
import { selectedClientInfoAtom } from '../state';

export function ClientInformationSectionWrapper() {
  const patientShortId = useAtomValue(selectedClientInfoAtom)?.patientShortId ?? '';

  return (
    <ClientInformationCardConnected
      patientShortId={patientShortId}
      isTelehealth
      patientNoteComponent={SelectedClientPatientNoteWrapper}
      isInverse
    />
  );
}
